<div class="mat-elevation-z8">
    <mat-card appearance="outlined">
        <mat-card-header class="text-uppercase tal">
            <mat-card-title>
                {{'consentsTexts.revokeConsent' | translate}}
                <span class="close">
                    <button class="close-btn" (click)="closeDialog(null)">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                </span>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="container">
            <div class="row">
                <div class="col-8 label">{{'consentsTexts.enterRevokeReason' | translate}}
                    <mat-form-field>
                        <input matInput placeholder="{{'consentsTexts.revokeReason' | translate}}"
                            [(ngModel)]="revokeReason" #reason="ngModel" required />
                        <mat-error *ngIf="reason.invalid">{{'consentsTexts.requiredField' | translate}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" id="save-btn-row">
                <div class="col-12">
                    <div align="end">
                        <button mat-button (click)="revoke()">{{'consentsTexts.saveConsent' | translate}}</button>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>